var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("COM_HeaderNav", { attrs: { mode: "uformData" } }),
      _c(
        "div",
        {
          staticClass: "btn-toolbar",
          attrs: { role: "toolbar", "aria-label": "Toolbar with button groups" }
        },
        [
          _c("div", {
            staticClass: "btn-group mr-2",
            attrs: { role: "group", "aria-label": "First group" }
          }),
          _c(
            "div",
            { staticClass: "btn-group mx-1", attrs: { role: "group" } },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary dropdown-toggle",
                  attrs: {
                    id: "btnGroupDrop1",
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [_vm._v(" 匯出 ")]
              ),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "btnGroupDrop1" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.$refs.grid.exportExcel()
                        }
                      }
                    },
                    [_vm._v("Excel")]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm.isMobile
        ? _c(
            "span",
            [
              _c("MyMobileList", {
                attrs: {
                  datas: _vm.gridDefine.datas,
                  "field-to-show": _vm.gridDefine.fieldToShow,
                  "swipe-setting": _vm.gridDefine.swipeSetting
                }
              })
            ],
            1
          )
        : _c(
            "span",
            [
              _c("MyKendoGrid", {
                ref: "grid",
                attrs: {
                  columns: _vm.gridDefine.columns,
                  datas: _vm.gridDefine.datas
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }